/**
 * Bar chart specific configurations
 * Note: dataSorting is intentionally disabled.
 * These options are defined to document the intended sorting behavior
 * and can be enabled conditionally (e.g., for TURF charts) in the future.
 */
export const barChartConfiguration = {
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
      },
      dataSorting: {
        enabled: false,
        matchByName: true,
        sortKey: 'y',
      },
      groupPadding: 0.1,
      pointPadding: 0.05,
    },
  },
};
